// extracted by mini-css-extract-plugin
module.exports = {"item":"_762907d","link":"_a2d4d88","iconOnly":"_fcb0cd1","icon":"_b70af91","text":"_7b5e7e0","activeLink":"_c780581"};